import React, { useState } from 'react';
import styles from '../ReportCard.module.scss';
import moment from 'moment';
import MiniMap from '../MiniMap';
import Pagination from './Pagination';
import SearchBar from './SearchBar';
import { formatDuration } from '../utils/formatDuration';

/**
 * Таблица загрузок со статусом "В погрузке".
 */
const InLoadingTableView = ({
  inLoadingLoads,
  inLoadingCount,
  inLoadingNext,
  inLoadingPrev,
  inLoadingPage,
  setInLoadingPage,
  inLoadingSearch,
  setInLoadingSearch,
  nowTime,
}) => {
  const [visibleMaps, setVisibleMaps] = useState({});
  const toggleMap = (id, geoType) => {
    const key = `${id}-${geoType}`;
    setVisibleMaps(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className={styles.table_info_wrapper}>
      <Pagination
        page={inLoadingPage}
        setPage={setInLoadingPage}
        count={inLoadingCount}
        hasNext={!!inLoadingNext}
        hasPrev={!!inLoadingPrev}
        shownCount={inLoadingLoads.length}
      />

      <SearchBar
        value={inLoadingSearch}
        onChange={setInLoadingSearch}
        onClear={() => setInLoadingSearch('')}
        placeholder="Поиск по водителю, телефону, Базе, номеру машины, модели машины..."
      />

      <div className={styles.cardGridView}>
        {(Array.isArray(inLoadingLoads) ? inLoadingLoads : []).map((item, index) => {
          const sequentialNumber = (inLoadingPage - 1) * 10 + index + 1;
          let timeA = null;
          if (item.time_a) {
            timeA = moment(item.time_a, 'DD.MM.YYYY HH:mm', true);
            if (!timeA.isValid()) {
              timeA = moment(item.time_a);
            }
          }
          const duration = timeA && timeA.isValid() ? formatDuration(timeA, nowTime) : '';

          return (
            <div key={item.id} className={styles.loadCard}>
              <div className={styles.loadCardHeader}>
                <div className={styles.vehicleNumberBox}>
                  <div className={styles.vehicleNumber}>{item.vehicle_number || '-'}</div>
                  <div className={styles.vehicleModel}>{item.vehicle_model || '-'}</div>
                </div>
                <div className={styles.statusBadgeCard} data-status="В погрузке">
                  В погрузке
                </div>
              </div>

              <div className={styles.loadCardBody}>
                {/* Driver & Base */}
                <div className={styles.infoBlock}>
                  <div className={styles.driverName}>
                    👤 {item.employee_name || 'Не указан'}
                  </div>
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Телефон:</span>
                    <span className={styles.infoValue}>{item.employee_phone || '-'}</span>
                  </div>
                  <div className={styles.infoRow} style={{ marginTop: '8px' }}>
                    <span className={styles.infoLabel}>База назначения:</span>
                    <span style={{ color: '#0d6efd', fontWeight: '700' }}>{item.top_base_name || item.chpp_name || item.private_point_name || '-'}</span>
                  </div>
                </div>

                {/* Time & Geo */}
                <div className={styles.timeGeoBlock} style={{ borderBottom: 'none', paddingBottom: 0 }}>
                  <div className={styles.timeGeoItem}>
                    <span className={styles.timeGeoLabel}>Въезд (Кара-Кече)</span>
                    <span className={styles.timeGeoValue}>{item.time_a || '-'}</span>
                  </div>
                  <div className={styles.timeGeoItem} style={{ alignItems: 'flex-end' }}>
                     <span className={styles.timeGeoLabel}>Геолокация</span>
                     <div style={{ display: 'flex', gap: '8px' }}>
                      {item.geo_a ? (
                        <>
                          <button
                            onClick={() => window.open(`https://www.google.com/maps?q=${item.geo_a}`, '_blank')}
                            className={styles.geoLinkBtn}
                            title="Карты"
                          >
                            Карты
                          </button>
                          <button
                            onClick={() => toggleMap(item.id, 'geo_a')}
                            className={styles.mapToggleBtn}
                            title="Показать"
                          >
                            {visibleMaps[`${item.id}-geo_a`] ? '✖' : '🗺️'}
                          </button>
                        </>
                      ) : <span style={{fontSize: '12px', color: '#999'}}>Нет данных</span>}
                    </div>
                  </div>

                  {/* Mark Info - Enhanced */}
                  <div className={styles.markedInfoBlock}>
                    <div className={styles.markedTitle}>Отметил въезд</div>
                    <div className={styles.markedName}>{item.guard_name || 'Не указан'}</div>
                    {item.guard_phone && (
                       <div className={styles.markedPhone}>
                         📞 {item.guard_phone}
                       </div>
                    )}
                  </div>
                </div>
                
                 {/* Map container */}
                 {item.geo_a && visibleMaps[`${item.id}-geo_a`] && (
                    <div style={{ height: '200px', borderRadius: '8px', overflow: 'hidden', marginBottom: '12px' }}>
                      <MiniMap geo={item.geo_a} />
                    </div>
                 )}
              </div>

              <div className={styles.loadCardFooter}>
                <div className={styles.notes} title={item.notes || 'Нет примечаний'}>
                  📝 {item.notes || 'Нет примечаний'}
                </div>
                {duration && (
                   <div className={styles.durationBadge}>
                     ⏱ {duration}
                   </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <Pagination
        page={inLoadingPage}
        setPage={setInLoadingPage}
        count={inLoadingCount}
        hasNext={!!inLoadingNext}
        hasPrev={!!inLoadingPrev}
        shownCount={inLoadingLoads.length}
        style={{ marginTop: '8px', marginBottom: 0 }}
      />
    </div>
  );
};

export default React.memo(InLoadingTableView);
